export const forBusiness_apparel_getStarted = [
	{
		icon: '🖼',
		title: 'getStartedData_title1',
		subtitle: 'getStartedData_subtitle1',
	},
	{
		icon: '✨',
		title: 'getStartedData_title2',
		subtitle: 'getStartedData_subtitle2',
	},
	{
		icon: '🎨',
		title: 'getStartedData_title3',
		subtitle: 'getStartedData_subtitle3',
	},
	{
		icon: '🚀',
		title: 'getStartedData_title4',
		subtitle: 'getStartedData_subtitle4',
	},
];
